import React, { useState, useEffect } from "react";
import { useAccount, useFeeData } from "wagmi";

import "flowbite";
import AdminPrifile from "./AdminProfile";
import { ToastContainer, toast } from "react-toastify";
import { IoIosAddCircleOutline } from "react-icons/io";
import { IoIosAddCircle } from "react-icons/io";
import { useSigner } from "wagmi";

import { SubscriptionAddress } from "../Contracts/Subscription";
import { SubscriptionAbi } from "../Contracts/Subscription";
import { ethers } from "ethers";
import Loading from "../Loading";

const privateKey = process.env.REACT_APP_ADMIN_PRIVATEkEY;
const NODE_URL = process.env.REACT_APP_NODE_URL;

const customProvider = new ethers.providers.JsonRpcProvider(NODE_URL);
const customSigner = new ethers.Wallet(privateKey, customProvider);

const DeletePackage = (props) => {
  const { data: signer } = useSigner();
  const [isLoading, setIsLoading] = useState(false);

  let contract;
  if (signer) {
    contract = new ethers.Contract(
      SubscriptionAddress,
      SubscriptionAbi,
      signer
    );
  }
  const remove = async (index) => {
    setIsLoading(true);
    await contract?.removeSubscriptionPlan(index).then(() => {
      props.closeRemoveBox().then(() => {
        setIsLoading(false);
    });
        setIsLoading(false);
    });
    setIsLoading(false);
  };
  return (
    <>
      <div
        className={"px-2 relative z-50 "}
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div
          className={`fixed inset-0 bg-black bg-opacity-20 transition-opacity`}
        ></div>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-2 text-center sm:items-center ">
            <div
              className={`relative bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] rounded-lg shadow dark:bg-gray-700 py-2`}
            >
              <div
                className={`bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] p-2`}
              >
                <div className="sm:flex sm:items-start">
                  <div className={`p-2 `}>
                    <h3 className="mb-2 text-xl font-medium text-white dark:text-white">
                      Are you sure to delete the box?
                    </h3>


                    <button
                      className="w-full mt-2 text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:red:bg-blue-700 dark:focus:ring-red-800"
                      onClick={() => remove(props.index)}
                    >
                      Delete Box
                    </button>
                  </div>
                </div>
              </div>
              <button
                onClick={props.closeRemoveBox}
                type="button"
                className="mx-4 mb-2 w-[90%] text-center rounded-lg bg-white px-5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 "
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      {<Loading isLoading={isLoading} />}
    </>
  );
};

export default DeletePackage;
